'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var core = require('@material-ui/core');
var icons = require('@material-ui/icons');
var ListItemWithIcon = require('../ListItemWithIcon/ListItemWithIcon.js');

var ParentListItem = function (props) {
    var closedIcon = props.closedIcon, openedIcon = props.openedIcon, _a = props.text, text = _a === void 0 ? '' : _a, _b = props.title, title = _b === void 0 ? '' : _b, children = props.children, onClick = props.onClick, narrowListIcon = props.narrowListIcon, _c = props.initialOpenState, initialOpenState = _c === void 0 ? 'closed' : _c;
    var _d = React.useState(initialOpenState === 'open'), open = _d[0], setOpen = _d[1];
    var rightIcon = open ? React__default.createElement(icons.ExpandLess, { style: { flex: 1 } }) : React__default.createElement(icons.ExpandMore, { style: { flex: 1 } });
    var icon = openedIcon && open ? openedIcon : closedIcon;
    var handleClick = function () {
        setOpen(!open);
        if (onClick) {
            onClick();
        }
    };
    return (React__default.createElement("div", null,
        React__default.createElement(ListItemWithIcon, { handleClick: handleClick, title: title, primaryText: text, leftIcon: icon, rightIcon: rightIcon, narrowListIcon: narrowListIcon }),
        React__default.createElement(core.Collapse, { in: open, timeout: 'auto', "data-testid": 'sub-menu' }, children)));
};

module.exports = ParentListItem;
